import Konva from "konva";
import React from "react";

import type { Point } from "~/tools/point";
import { usePermanent } from "~/tools/use-permanent";

import { AssignNodeField } from "./_AssignNodeField";
import { Shape, type ShapeConfig } from "./Shape";

export interface LineConfig extends ShapeConfig {
	points: ReadonlyArray<Point>;
}

export type LineProps = LineConfig;

export const Line: React.FC<LineProps> = ({ points, ...config }) => {
	const flatPoints = points.flatMap(({ x, y }) => [x, y]);
	const line = usePermanent(() => new Konva.Line({ points: flatPoints, ...config }));

	return (
		<Shape instance={line} {...config}>
			<AssignNodeField instance={line} method="points" serialize value={flatPoints} />
		</Shape>
	);
};
